import { actionCreator } from './actionCreatorFunction';
import { reducerHandler } from './reducerHandler';

// Actions and Types
const getEmployeeListAction = actionCreator('GET_EMPLOYEE_LIST_ACTION');
const deleteEmployeeAction = actionCreator('DELETE_EMPLOYEE');
const editEmployeeProfileAction = actionCreator('EDIT_EMPLOYEE_PROFILE');
const getEmployeeAction = actionCreator('GET_EMPLOYEE');
const registerUserAction = actionCreator('REGISTER_USER');
const getHolidayRequestAction = actionCreator('GET_HOLIDAY_REQUEST');
const getDemandHistoryAction = actionCreator('GET_DEMAND_HISTORY');
const updateDemandStatusAction = actionCreator('UPDATE_DEMAND_STATUS');
const getOneDemandAction = actionCreator('GET_ONE_DEMAND');
const getDemandTypeAction = actionCreator('GET_DEMAND_TYPE');
const editDemandStatusAction = actionCreator('EDIT_DEMAND_STATUS');

// Initial State
const initialAsyncState = {
  isLoading: false,
  loaded: false,
  data: null,
  error: null,
};

// Initial Reducer State
const initialState = {
  employeeList: initialAsyncState,
  employeeDeleting: initialAsyncState,
  employeeProfile: initialAsyncState,
  employee: initialAsyncState,
  userRegistration: initialAsyncState,
  holidayRequest: initialAsyncState,
  demandHistory: initialAsyncState,
  demandStatus: initialAsyncState,
  OneDemandDetails: initialAsyncState,
  demandType: initialAsyncState,
  demandStatusEditing: initialAsyncState,
};

// Reducer
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case getEmployeeListAction.REQUEST:
    case getEmployeeListAction.SUCCESS:
    case getEmployeeListAction.FAILURE:
      return {
        ...state,
        employeeList: reducerHandler(state.employeeList, action, getEmployeeListAction),
      };
    case deleteEmployeeAction.REQUEST:
    case deleteEmployeeAction.SUCCESS:
    case deleteEmployeeAction.FAILURE:
      return {
        ...state,
        employeeDeleting: reducerHandler(state.employeeDeleting, action, deleteEmployeeAction),
      };
    case editEmployeeProfileAction.REQUEST:
    case editEmployeeProfileAction.SUCCESS:
    case editEmployeeProfileAction.FAILURE:
      return {
        ...state,
        employeeProfile: reducerHandler(state.employeeProfile, action, editEmployeeProfileAction),
      };
    case getEmployeeAction.REQUEST:
    case getEmployeeAction.SUCCESS:
    case getEmployeeAction.FAILURE:
      return {
        ...state,
        employee: reducerHandler(state.employee, action, getEmployeeAction),
      };
    case registerUserAction.REQUEST:
    case registerUserAction.SUCCESS:
    case registerUserAction.FAILURE:
      return {
        ...state,
        userRegistration: reducerHandler(state.userRegistration, action, registerUserAction),
      };
    case getHolidayRequestAction.REQUEST:
    case getHolidayRequestAction.SUCCESS:
    case getHolidayRequestAction.FAILURE:
      return {
        ...state,
        holidayRequest: reducerHandler(state.holidayRequest, action, getHolidayRequestAction),
      };
    case getDemandHistoryAction.REQUEST:
    case getDemandHistoryAction.SUCCESS:
    case getDemandHistoryAction.FAILURE:
      return {
        ...state,
        demandHistory: reducerHandler(state.demandHistory, action, getDemandHistoryAction),
      };
    case updateDemandStatusAction.REQUEST:
    case updateDemandStatusAction.SUCCESS:
    case updateDemandStatusAction.FAILURE:
      return {
        ...state,
        demandStatus: reducerHandler(state.demandStatus, action, updateDemandStatusAction),
      };
    case getOneDemandAction.REQUEST:
    case getOneDemandAction.SUCCESS:
    case getOneDemandAction.FAILURE:
      return {
        ...state,
        OneDemandDetails: reducerHandler(state.OneDemandDetails, action, getOneDemandAction),
      };
    case getDemandTypeAction.REQUEST:
    case getDemandTypeAction.SUCCESS:
    case getDemandTypeAction.FAILURE:
      return {
        ...state,
        demandType: reducerHandler(state.demandType, action, getDemandTypeAction),
      };
    case editDemandStatusAction.REQUEST:
    case editDemandStatusAction.SUCCESS:
    case editDemandStatusAction.FAILURE:
      return {
        ...state,
        demandStatusEditing: reducerHandler(state.demandStatusEditing, action, editDemandStatusAction),
      };
    default:
      return state;
  }
};
export { reducer };
export {
  getEmployeeListAction,
  getEmployeeAction,
  deleteEmployeeAction,
  editEmployeeProfileAction,
  getDemandHistoryAction,
  getHolidayRequestAction,
  registerUserAction,
  updateDemandStatusAction,
  getOneDemandAction,
  getDemandTypeAction,
  editDemandStatusAction,
};
